import { render, staticRenderFns } from "./SpouseContactData.vue?vue&type=template&id=7e50be80&"
import script from "./SpouseContactData.vue?vue&type=script&lang=js&"
export * from "./SpouseContactData.vue?vue&type=script&lang=js&"
import style0 from "./SpouseContactData.vue?vue&type=style&index=0&id=7e50be80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports